import type { RouteDataFunc } from "@solidjs/router";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import { BaseApi } from "~/solidJs/shared/api/baseApi";
import { getUserAndSetStore, isAuthenticated } from "~/solidJs/shared/helpers/userHelpers";

export class TeamInvitationApi extends BaseApi {
	static teamInvitationLocalStorageKey = "team_invitation_token";

	static saveTeamInvitationToken(token: string) {
		localStorage.setItem(TeamInvitationApi.teamInvitationLocalStorageKey, token);
	}

	static getTeamInvitationToken(): string | null {
		return localStorage.getItem(TeamInvitationApi.teamInvitationLocalStorageKey);
	}

	static removeTeamInvitationToken() {
		localStorage.removeItem(TeamInvitationApi.teamInvitationLocalStorageKey);
	}
}

export const teamInvitationData: RouteDataFunc = async (props) => {
	const token = props.location.query.token;
	if (!token) {
		props.navigate(routerConfig.signIn.absolute, { replace: true });
		EventAnalytics.sendErrorInfo("team_invitation_no_token_error", {
			message: "No token provided"
		});
		return;
	}

	// Save token to localStorage (do not sign out)
	TeamInvitationApi.saveTeamInvitationToken(token);

	// Check if user has active session
	const user = await getUserAndSetStore();
	const hasSession = isAuthenticated(user);

	if (hasSession) {
		// Redirect to account page if user is authenticated
		props.navigate(routerConfig.account.absolute, { replace: true });
	} else {
		// Redirect to sign in page if user is not authenticated
		props.navigate(routerConfig.signIn.absolute, { replace: true });
	}
};
